(function () {
  'use strict';

  function refreshCartAndOpenDrawer() {
    return fetch('?section_id=helper-cart')
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(text, 'text/html');
        var cartForm = document.getElementById('AjaxCartForm');
        var cartSubtotal = document.getElementById('AjaxCartSubtotal');
        var formHtml = doc.getElementById('AjaxCartForm');
        var subtotalHtml = doc.getElementById('AjaxCartSubtotal');
        if (cartForm && formHtml) {
          cartForm.innerHTML = formHtml.innerHTML;
          if (typeof cartForm.ajaxifyCartItems === 'function') cartForm.ajaxifyCartItems();
          if (typeof cartForm.initializeSubscriptionDetails === 'function') cartForm.initializeSubscriptionDetails();
        }
        if (cartSubtotal && subtotalHtml) cartSubtotal.innerHTML = subtotalHtml.innerHTML;
        document.querySelectorAll('[data-header-cart-count]').forEach(function (el) {
          var countEl = document.querySelector('#AjaxCartForm [data-cart-count]');
          if (countEl) el.textContent = countEl.textContent;
        });
        document.querySelectorAll('[data-header-cart-total]').forEach(function (el) {
          var totalEl = document.querySelector('#AjaxCartForm [data-cart-total]');
          if (totalEl) el.textContent = totalEl.textContent;
        });
        var drawer = document.querySelector('[data-js-site-cart-sidebar]') || document.getElementById('site-cart-sidebar');
        if (drawer && typeof drawer.show === 'function') drawer.show();
        if (typeof window.refreshCartPaymentMethods === 'function') {
          setTimeout(window.refreshCartPaymentMethods, 100);
        }
      })
      .catch(function () {});
  }

  function initSubscriptionFeed(container) {
    if (!container) return;

    var sectionId = container.getAttribute('data-section-id');
    var defaultPaymentType = container.getAttribute('data-default-payment-type') || 'pay_per_month';
    var cardsContainer = container.querySelector('[data-subscription-feed-cards]');
    var toggleWrapper = container.querySelector('[data-subscription-feed-toggle-wrapper]') ||
      (container.closest('.subscription-feed-container-parent') && container.closest('.subscription-feed-container-parent').querySelector('[data-subscription-feed-toggle-wrapper]'));

    function syncFormFromVisiblePicker(card) {
      var form = card.querySelector('.subscription-feed-card__form');
      if (!form) return;
      var hiddenId = form.querySelector('[data-subscription-feed-form-variant-id]');
      var hiddenPlan = form.querySelector('[data-subscription-feed-form-selling-plan]');
      if (!hiddenId || !hiddenPlan) return;

      var visiblePickerWrapper = card.querySelector('.subscription-feed-card__picker--visible');
      if (!visiblePickerWrapper) return;

      var picker = visiblePickerWrapper.querySelector('[data-subscription-feed-picker]');
      if (!picker) return;
      var select = picker.querySelector('[data-subscription-feed-variant-select]');
      var dataEl = picker.querySelector('[data-subscription-feed-variant-data]');
      if (!select || !dataEl) return;

      var variantId = select.value;
      var nodes = dataEl.querySelectorAll('[data-variant-id]');
      var btn = form.querySelector('[data-js-subscription-feed-add-to-cart]');
      for (var i = 0; i < nodes.length; i++) {
        if (String(nodes[i].getAttribute('data-variant-id')) === String(variantId)) {
          hiddenId.value = variantId;
          hiddenId.setAttribute('value', variantId);
          hiddenPlan.value = nodes[i].getAttribute('data-selling-plan-id') || '';
          hiddenPlan.setAttribute('value', hiddenPlan.value);
          var available = nodes[i].getAttribute('data-available') !== 'false';
          if (btn) {
            btn.disabled = !available;
            btn.setAttribute('aria-disabled', available ? 'false' : 'true');
          }
          return;
        }
      }
      if (btn) { btn.disabled = true; btn.setAttribute('aria-disabled', 'true'); }
    }

    function getIntervalLabel(intervalKey, intervalCount) {
      var locales = typeof window.KROWN !== 'undefined' && window.KROWN.settings && window.KROWN.settings.locales ? window.KROWN.settings.locales : {};
      var key = (intervalKey || '').toLowerCase();
      var label = locales.months || 'Month(s)';
      if (key === 'day') label = locales.days || 'Day(s)';
      else if (key === 'week') label = locales.weeks || 'Week(s)';
      else if (key === 'month') label = locales.months || 'Month(s)';
      else if (key === 'year') label = locales.years || 'Year(s)';
      return label;
    }

    function formatShippingInterval(interval, intervalCount) {
      var locales = typeof window.KROWN !== 'undefined' && window.KROWN.settings && window.KROWN.settings.locales ? window.KROWN.settings.locales : {};
      var template = locales.subscription_details || locales.subscription_detail || 'Shipping every {{ intervalCount }} {{ interval }}';
      var label = getIntervalLabel(interval, intervalCount);
      return template
        .replace('{{ intervalCount }}', intervalCount)
        .replace('{{ interval }}', label);
    }

    function fetchShippingIntervalFromApi(variantId, intervalDisplay, planNameFallback) {
      var proxyUrl = typeof window.jpapp !== 'undefined' && window.jpapp.proxyUrl ? window.jpapp.proxyUrl : '';
      var apiPath = typeof window.KROWN !== 'undefined' && window.KROWN.settings && window.KROWN.settings.subscription_api && window.KROWN.settings.subscription_api.get_selling_plan_info_by_variant_id
        ? window.KROWN.settings.subscription_api.get_selling_plan_info_by_variant_id
        : '';
      if (!proxyUrl || !apiPath || !variantId || !intervalDisplay) return;
      var url = proxyUrl + apiPath + '?variantId=' + encodeURIComponent(variantId);
      fetch(url, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' }
      })
        .then(function (res) { return res.ok ? res.json() : Promise.reject(new Error('API ' + res.status)); })
        .then(function (data) {
          var error = data.error;
          var sellingPlan = data.sellingPlan;
          if (error || !sellingPlan || !sellingPlan.deliveryPolicy) {
            if (planNameFallback && intervalDisplay) intervalDisplay.textContent = planNameFallback;
            return;
          }
          
          var deliveryPolicy = sellingPlan.deliveryPolicy;
          var isInstallment = sellingPlan.sellingPlanType === 'installment';
          var interval = deliveryPolicy.interval || '';
          var intervalCount = (isInstallment && sellingPlan.originalIntervalCount != null)
            ? String(sellingPlan.originalIntervalCount)
            : (deliveryPolicy.intervalCount != null ? String(deliveryPolicy.intervalCount) : '1');
          if (interval && intervalDisplay) {
            intervalDisplay.textContent = formatShippingInterval(interval, intervalCount);
          } else if (planNameFallback && intervalDisplay) {
            intervalDisplay.textContent = planNameFallback;
          }
        })
        .catch(function () {
          if (planNameFallback && intervalDisplay) intervalDisplay.textContent = planNameFallback;
        });
    }

    function updatePickerDisplay(picker, variantId) {
      var dataEl = picker.querySelector('[data-subscription-feed-variant-data]');
      var priceDisplay = picker.querySelector('[data-subscription-feed-price-display]');
      var card = picker.closest('.subscription-feed-card');
      var intervalDisplay = card ? card.querySelector('[data-subscription-feed-interval-display]') : null;
      if (!dataEl) return;

      var nodes = dataEl.querySelectorAll('[data-variant-id]');
      for (var i = 0; i < nodes.length; i++) {
        if (String(nodes[i].getAttribute('data-variant-id')) === String(variantId)) {
          var paymentType = picker.getAttribute('data-payment-type');
          var priceFormatted = nodes[i].getAttribute('data-price-formatted');
          var priceMonthlyFormatted = nodes[i].getAttribute('data-price-monthly-formatted');
          var interval = nodes[i].getAttribute('data-interval');
          var intervalCount = nodes[i].getAttribute('data-interval-count');
          var planName = nodes[i].getAttribute('data-plan-name');
          var hasTax = nodes[i].getAttribute('data-has-tax') === 'true';

          if (priceDisplay) {
            var amountEl = priceDisplay.querySelector('[data-js-subscription-feed-price]');
            var freqEl = priceDisplay.querySelector('.subscription-feed-card__price-frequency');
            if (amountEl) {
              amountEl.textContent = paymentType === 'pay_per_month' && priceMonthlyFormatted
                ? priceMonthlyFormatted
                : priceFormatted;
            }
            if (freqEl) {
              var feedEl = picker.closest('.subscription-feed');
              var freqMonth = feedEl ? feedEl.getAttribute('data-price-frequency-per-month') : '';
              var freqShip = feedEl ? feedEl.getAttribute('data-price-frequency-per-shipment') : '';
              freqEl.textContent = paymentType === 'pay_per_month' ? (freqMonth || '/ month') : (freqShip || '/ shipment');
            }
            var vatLabel = priceDisplay.querySelector('[data-subscription-feed-vat-label]');
            if (vatLabel) {
              vatLabel.style.display = hasTax ? '' : 'none';
            }
          }
          if (intervalDisplay) {
            if (interval && intervalCount) {
              intervalDisplay.textContent = formatShippingInterval(interval, intervalCount);
            } else if (typeof window.KROWN !== 'undefined' && typeof window.jpapp !== 'undefined' && window.jpapp.proxyUrl) {
              fetchShippingIntervalFromApi(variantId, intervalDisplay, planName || '');
            } else if (planName) {
              intervalDisplay.textContent = planName;
            } else {
              intervalDisplay.textContent = '';
            }
          }

          var monthlyTotalRow = card ? card.querySelector('[data-subscription-feed-monthly-total]') : null;
          if (monthlyTotalRow) {
            var totalMonthlyRaw = nodes[i].getAttribute('data-total-monthly-val');
            var totalMonthlyVal = totalMonthlyRaw && String(totalMonthlyRaw).trim();
            if (paymentType === 'pay_per_month' && totalMonthlyVal) {
              monthlyTotalRow.classList.remove('display-none');
              var monthlyValEl = monthlyTotalRow.querySelector('[data-subscription-feed-monthly-value]');
              if (monthlyValEl) monthlyValEl.innerHTML = totalMonthlyVal;
            } else {
              monthlyTotalRow.classList.add('display-none');
              var monthlyValClear = monthlyTotalRow.querySelector('[data-subscription-feed-monthly-value]');
              if (monthlyValClear) monthlyValClear.innerHTML = '';
            }
          }
          return;
        }
      }
    }
    if (toggleWrapper) {
      var options = toggleWrapper.querySelectorAll('.subscription-feed__toggle-option');
      var radios = toggleWrapper.querySelectorAll('input[type="radio"]');

      function applyPaymentType(selectedType) {
        options.forEach(function (opt) {
          opt.classList.toggle('is-selected', opt.getAttribute('data-payment-type') === selectedType);
        });

        var cards = container.querySelectorAll('.js-subscription-feed-card');
        cards.forEach(function (card) {
          var hasMonth = card.getAttribute('data-has-pay-per-month') === 'true';
          var hasShipment = card.getAttribute('data-has-pay-per-shipment') === 'true';
          var showCard = (selectedType === 'pay_per_month' && hasMonth) || (selectedType === 'pay_per_shipment' && hasShipment);
          card.classList.toggle('subscription-feed-card--hidden', !showCard);

          var pickerMonth = card.querySelector('.subscription-feed-card__picker--pay-per-month');
          var pickerShipment = card.querySelector('.subscription-feed-card__picker--pay-per-shipment');
          if (pickerMonth) {
            pickerMonth.style.display = selectedType === 'pay_per_month' ? '' : 'none';
            pickerMonth.classList.toggle('subscription-feed-card__picker--visible', selectedType === 'pay_per_month');
          }
          if (pickerShipment) {
            pickerShipment.style.display = selectedType === 'pay_per_shipment' ? '' : 'none';
            pickerShipment.classList.toggle('subscription-feed-card__picker--visible', selectedType === 'pay_per_shipment');
          }

          if (showCard) {
            syncFormFromVisiblePicker(card);
            var visiblePicker = card.querySelector('.subscription-feed-card__picker--visible');
            if (visiblePicker) {
              var sel = visiblePicker.querySelector('[data-subscription-feed-variant-select]');
              if (sel) updatePickerDisplay(visiblePicker, sel.value);
            }
          }
        });
      }

      radios.forEach(function (radio) {
        radio.addEventListener('change', function () {
          applyPaymentType(this.value);
        });
      });

      var checkedRadio = toggleWrapper.querySelector('input[type="radio"]:checked');
      if (checkedRadio) {
        var slider = container.querySelector('css-slider');
        if (slider && !slider.sliderEnabled) {
          slider.addEventListener('ready', function onSliderReady() {
            slider.removeEventListener('ready', onSliderReady);
            applyPaymentType(checkedRadio.value);
          });
        } else {
          applyPaymentType(checkedRadio.value);
        }
      }
    }

    function syncAllVisibleCardPickers() {
      container.querySelectorAll('.js-subscription-feed-card').forEach(function (card) {
        if (card.classList.contains('subscription-feed-card--hidden')) return;
        var visiblePicker = card.querySelector('.subscription-feed-card__picker--visible');
        if (!visiblePicker) return;
        var sel = visiblePicker.querySelector('[data-subscription-feed-variant-select]');
        if (sel) updatePickerDisplay(visiblePicker, sel.value);
        syncFormFromVisiblePicker(card);
      });
    }

    function attachPickerAndFormListeners() {
      container.querySelectorAll('[data-subscription-feed-picker]').forEach(function (picker) {
        var select = picker.querySelector('[data-subscription-feed-variant-select]');
        var dataEl = picker.querySelector('[data-subscription-feed-variant-data]');
        if (!select || !dataEl) return;

        var card = picker.closest('.subscription-feed-card');
        if (!card) return;

        function onSelectChange() {
          updatePickerDisplay(picker, select.value);
          syncFormFromVisiblePicker(card);
        }

        select.addEventListener('change', onSelectChange);
      });

      container.querySelectorAll('[data-type="subscription-feed-add-to-cart"]').forEach(function (form) {
        form.addEventListener('submit', async function (e) {
          var card = form.closest('.subscription-feed-card');
          if (!card || card.classList.contains('subscription-feed-card--hidden')) return;

          syncFormFromVisiblePicker(card);

          var idInput = form.querySelector('input[name="id"]');
          var planInput = form.querySelector('input[name="selling_plan"]');
          var btn = form.querySelector('[data-js-subscription-feed-add-to-cart]');
          if (!idInput || !idInput.value) {
            e.preventDefault();
            return;
          }
          if (btn && btn.disabled) {
            e.preventDefault();
            return;
          }

          e.preventDefault();

          document.dispatchEvent(new Event('checkout-buttons-section:show-loader', { bubbles: true }));

          var cartAddUrl = typeof window.KROWN !== 'undefined' && window.KROWN.settings && window.KROWN.settings.routes && window.KROWN.settings.routes.cart_add_url;
          if (!cartAddUrl) {
            form.submit();
            return;
          }

          var visiblePicker = card.querySelector('.subscription-feed-card__picker--visible');
          var isPayPerMonth = visiblePicker && visiblePicker.getAttribute('data-payment-type') === 'pay_per_month';
          var selectedPaymentMethod = (typeof window.cartDataForPaymentSelectionInCart !== 'undefined' && window.cartDataForPaymentSelectionInCart && window.cartDataForPaymentSelectionInCart.attributes && window.cartDataForPaymentSelectionInCart.attributes._paymentMethod) || (typeof window.cartAvailablePaymentMethods !== 'undefined' && window.cartAvailablePaymentMethods && window.cartAvailablePaymentMethods.subscription && window.cartAvailablePaymentMethods.subscription[0]) || 'Online';
          var isManualPayment = typeof window.KROWN !== 'undefined' && window.KROWN.settings && window.KROWN.settings.manualPaymentTypes && window.KROWN.settings.manualPaymentTypes.indexOf(selectedPaymentMethod) > -1;

          var item = { id: parseInt(idInput.value, 10), quantity: 1 };
          if (planInput && planInput.value && !isManualPayment) {
            item.selling_plan = parseInt(planInput.value, 10);
          }

          var variantDataEl = visiblePicker && visiblePicker.querySelector('[data-subscription-feed-variant-data] [data-variant-id="' + idInput.value + '"]');
          var planName = variantDataEl ? (variantDataEl.getAttribute('data-plan-name') || variantDataEl.getAttribute('data-subscription-name') || '') : '';
          var subscriptionType = variantDataEl ? (variantDataEl.getAttribute('data-payment-type') || '') : (isPayPerMonth ? 'installment' : 'normal');
          var discountValue = variantDataEl ? (variantDataEl.getAttribute('data-discount-value') || '') : '';
          item.properties = {
            _subscriptionType: subscriptionType,
            _sellingplan: isManualPayment && planInput && planInput.value ? String(planInput.value) : '',
            _selling_plan_name: planName,
            _discountvalue: discountValue,
            _ots_installment: 'false'
          };

          var formData = { items: [item] };

          if (btn) {
            btn.classList.add('working');
            btn.disabled = true;
          }

          try {
            if (isPayPerMonth && typeof window.addInstallmentFee === 'function') {
              await window.addInstallmentFee(isManualPayment);
            }
            var res = await fetch(cartAddUrl + '.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(formData)
            });
            var data = await res.json().catch(function () { return {}; });

            if (res.status === 422) {
              var alertEl = document.createElement('span');
              alertEl.className = 'alert alert--error';
              alertEl.innerHTML = typeof data.description === 'string' ? data.description : (data.message || 'Unable to add this item to the cart.');
              var sectionRes = await fetch('?section_id=helper-cart').then(function (r) { return r.text(); });
              var sectionDoc = new DOMParser().parseFromString(sectionRes, 'text/html');
              var cartForm = document.getElementById('AjaxCartForm');
              var cartSubtotal = document.getElementById('AjaxCartSubtotal');
              var formHtml = sectionDoc.getElementById('AjaxCartForm');
              var subtotalHtml = sectionDoc.getElementById('AjaxCartSubtotal');
              if (cartForm && formHtml) {
                cartForm.innerHTML = formHtml.innerHTML;
                if (typeof cartForm.ajaxifyCartItems === 'function') cartForm.ajaxifyCartItems();
                if (typeof cartForm.initializeSubscriptionDetails === 'function') cartForm.initializeSubscriptionDetails();
                var formInside = cartForm.querySelector('form');
                if (formInside) formInside.insertBefore(alertEl, formInside.firstChild);
              }
              if (cartSubtotal && subtotalHtml) cartSubtotal.innerHTML = subtotalHtml.innerHTML;
              document.querySelectorAll('[data-header-cart-count]').forEach(function (el) {
                var countEl = document.querySelector('#AjaxCartForm [data-cart-count]');
                if (countEl) el.textContent = countEl.textContent;
              });
              document.querySelectorAll('[data-header-cart-total]').forEach(function (el) {
                var totalEl = document.querySelector('#AjaxCartForm [data-cart-total]');
                if (totalEl) el.textContent = totalEl.textContent;
              });
              var drawer = document.querySelector('[data-js-site-cart-sidebar]') || document.getElementById('site-cart-sidebar');
              if (drawer && typeof drawer.show === 'function') drawer.show();
              if (typeof window.refreshCartPaymentMethods === 'function') {
                setTimeout(window.refreshCartPaymentMethods, 100);
              }
              return;
            }

            if (!res.ok) {
              console.error('Error adding to cart:', data);
              throw new Error('Failed to add to cart');
            }
            if (typeof window.refreshCartForPartner === 'function') {
              await window.refreshCartForPartner();
            } else {
              await refreshCartAndOpenDrawer();
            }
          } catch (err) {
            console.error('Error adding to cart:', err);
          } finally {
            if (btn) {
              btn.classList.remove('working');
              syncFormFromVisiblePicker(card);
            }
          }
        });
      });

      syncAllVisibleCardPickers();
    }

    var sliderForListeners = container.querySelector('css-slider');
    if (sliderForListeners && !sliderForListeners.sliderEnabled) {
      sliderForListeners.addEventListener('ready', function onSliderReadyForListeners() {
        sliderForListeners.removeEventListener('ready', onSliderReadyForListeners);
        attachPickerAndFormListeners();
      });
    } else {
      attachPickerAndFormListeners();
    }
  }

  function init() {
    document.querySelectorAll('.subscription-feed').forEach(initSubscriptionFeed);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.subscription-feed');
    if (section) initSubscriptionFeed(section);
  });

  // Handle smooth scroll for "exclude this step" link
  document.addEventListener('click', function (e) {
    var excludeLink = e.target.closest('[data-exclude-this-step]');
    if (excludeLink) {
      var targetSectionId = excludeLink.getAttribute('data-target-section');
      if (targetSectionId) {
        e.preventDefault();
        e.stopPropagation();
        var targetElement = document.getElementById(targetSectionId);
        if (targetElement) {
          targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }
    }
  });
})();